import React, { useEffect, useState, useRef } from "react";
import short1 from "../Images/SearchImage/video/video1.mp4";
import short2 from "../Images/SearchImage/video/video2.mp4";
import short3 from "../Images/SearchImage/video/video3.mp4";
import short5 from "../Images/SearchImage/video/video5.mp4";
import short6 from "../Images/SearchImage/video/video6.mp4";
import short7 from "../Images/SearchImage/video/first.mp4";
import short8 from "../Images/SearchImage/video/second.mp4";
import short9 from "../Images/SearchImage/video/thirds.mp4";
import short10 from "../Images/SearchImage/video/fourth.mp4";
import short11 from "../Images/SearchImage/video/fifth.mp4";
import short12 from "../Images/SearchImage/video/six.mp4";
import short13 from "../Images/SearchImage/video/seven.mp4";
import short14 from "../Images/SearchImage/video/eight.mp4";
import short15 from "../Images/SearchImage/video/nine.mp4";
import short16 from "../Images/SearchImage/video/ten.mp4";
import short17 from "../Images/SearchImage/video/eleven.mp4";
import short18 from "../Images/SearchImage/video/twelve.mp4";
import VideoCard from "./VideoCard";

const ShortVideo = () => {
  const getVideos = () => {
    const videoSources = [
      { id: 1, src: short1 },
      { id: 2, src: short2 },
      { id: 3, src: short3 },
      { id: 4, src: short5 },
      { id: 5, src: short6 },
      { id: 6, src: short7 },
      { id: 7, src: short8 },
      { id: 8, src: short9 },
      { id: 9, src: short10 },
      { id: 10, src: short11 },
      { id: 11, src: short12 },
      { id: 12, src: short13 },
      { id: 13, src: short14 },
      { id: 14, src: short15 },
      { id: 15, src: short16 },
      { id: 16, src: short17 },
      { id: 17, src: short18 },
    ];
    setVideos(videoSources);
  };
  const [videos, setVideos] = useState([]);
  const videoRefs = useRef([]);

  useEffect(() => {
    getVideos();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = videoRefs.current[entry.target.dataset.index];
          if (entry.isIntersecting) {
            video.muted = true;
            video
              .play()
              .catch((error) => console.error("Video play failed:", error));
          } else {
            video?.pause();
            video.currentTime = 0;
          }
        });
      },
      { threshold: 0.75 }
    );
    videoRefs?.current.forEach((video) => {
      if (video) observer.observe(video);
    });

    return () => {
      videoRefs?.current.forEach((video) => {
        if (video) observer.unobserve(video);
      });
    };
  }, [videos]);

  const handleVideoClick = (index) => {
    const video = videoRefs?.current[index];
    video.muted = !video.muted;
    video.play().catch((error) => console.error("Video play failed:", error));
  };
  return (
    <>
      <div>
        <main className="p-0 hstack justify-content-center m-auto">
          <div className="slider-container blank">
            {videos.map((video, id) => (
              <VideoCard
                key={id}
                index={id}
                src={video.src}
                videoRef={(el) => (videoRefs.current[id] = el)}
                onClick={() => handleVideoClick(id)}
              />
            ))}
          </div>
        </main>
      </div>
    </>
  );
};

export default ShortVideo;
